import { render, staticRenderFns } from "./ForVerification.vue?vue&type=template&id=cb7bc558&scoped=true"
import script from "./ForVerification.vue?vue&type=script&lang=js"
export * from "./ForVerification.vue?vue&type=script&lang=js"
import style0 from "./ForVerification.vue?vue&type=style&index=0&id=cb7bc558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7bc558",
  null
  
)

export default component.exports